import { cn } from '../../lib/cn';
import type { ComplianceDashboardRow } from '../../securitygovernance/framework';

type Props = { items?: ComplianceDashboardRow[] };

export function ComplianceDashboardPanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item) => (
        <div key={item.metric} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{item.metric}</p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-slate-100">{item.value}</p>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full', item.score >= 90 ? 'bg-success-500' : 'bg-brand-500')} style={{ width: `${item.score}%` }} />
          </div>
          <span className={cn(
            'mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-medium',
            item.status === 'healthy' || item.status === 'compliant' || item.status === 'on_track'
              ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
              : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
          )}>
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
